export default __webpack_public_path__ + "static/icon-3a8bafe906fcd2ce776ca2d6f14e8447.png";